import { triggerTracking } from '@zoopla/tracking';
import {
    AnalyticsEcommerce,
    AnalyticsEcommerceImpression
} from '@zoopla/listing-search-context';

export const agentLogoTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'clickthrough',
        eventLabel: 'listing_agent_logo'
    });
};

export const agentPhoneTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'call',
        eventLabel: 'branch_id'
    });
};

export const phoneNumberRevealTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'click',
        eventLabel: 'reveal agent number'
    });
};

export const agentContactTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'contact_agent'
    });
};

export const listingContentTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_content'
    });
};

export const imageTracking = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search results',
        eventAction: 'listing_clickthrough',
        eventLabel: 'listing_image'
    });
};

const trackedListingIds = new Set<string>();

export const imageGalleryControlTracking = (listingId: string) => {
    if (trackedListingIds.has(listingId) === false) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'search results',
            eventAction: 'image_gallery_scroll',
            eventLabel: listingId
        });
        trackedListingIds.add(listingId);
    }
};

export const ecommerceClickTracking = (
    productImpression: AnalyticsEcommerceImpression,
    listName = 'Search results'
) => {
    triggerTracking({
        event: 'GAEventEcommerce',
        ecommerce: {
            click: {
                actionField: {
                    list: listName
                },
                products: [
                    {
                        id: productImpression.id,
                        variant: productImpression.variant,
                        position: productImpression.position
                    }
                ]
            }
        }
    });
};

export const getEcommerceDataForListing = (
    analyticsEcommerce: AnalyticsEcommerce,
    listingId: string
) =>
    analyticsEcommerce.impressions?.find(
        (product) => product.id.toString() === listingId
    );
